import { BaseViewModel } from "../../common/BaseViewModel";
import * as Format from "../../common/FormatFunctions";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import * as ApiService from "../../common/CloudService/ApiService";
import { CrudlStatus } from "../../common/config/AppConstants";
import * as UIMap from "../../common/PrimeComponents";
export class OrderViewModel extends BaseViewModel {
  constructor(updateState, showError, showSuccess, showEmpty) {
    super();
    this.updateState = updateState;
    this.showError = showError;
    this.showSuccess = showSuccess;
    this.showEmpty = showEmpty;
  }

  showLoadingScreen = () => {
    this.updateState("loaded", false);
  };

  hideLoadingScreen = () => {
    this.updateState("loaded", true);
  };

  getStations = async () => {
    var stationResponse = await this.getStationListByCodeTag();
    if (Format.isNotNull(stationResponse.stationList)) {
      this.updateState("flowStationList", stationResponse.stationList);
      this.logger.info(stationResponse.stationList);
    } else {
      //this.showError("Station", CrudlStatus.LIST);
    }
  };

  getCustomers = async () => {
    var customerResponse = await this.getCustomerListByCodeTag();
    if (Format.isNotNull(customerResponse.businesses)) {
      this.updateState("customerList", customerResponse.businesses);
      this.logger.info(customerResponse.businesses);
      var customerArray = UIMap.getDropdownOptionsExtension(
        customerResponse.businesses,
        "businessName",
        "id"
      );
      this.updateState("customerOptions", customerArray);
    } else {
      // this.showError("Customer", CrudlStatus.LIST);
    }
  };

  getProducts = async () => {
    var productResponse = await this.getProductListByCodeTag();
    if (Format.isNotNull(productResponse.productList)) {
      this.updateState("productList", productResponse.productList);
      this.logger.info(productResponse.productList);
    } else {
      // this.showError("Product", CrudlStatus.LIST);
    }
  };

  getParts = async () => {
    var partResponse = await this.getPartListByCodeTag();
    if (Format.isNotNull(partResponse.partList)) {
      this.updateState("partList", partResponse.partList);
      this.logger.info(partResponse.partList);
    } else {
      //this.showError("Part", CrudlStatus.LIST);
    }
  };

  getCatalogues = async () => {
    var catalogueResponse = await this.getCatalogueListByCodeTag();
    if (Format.isNotNull(catalogueResponse.catalogueList)) {
      this.updateState("catalogueList", catalogueResponse.catalogueList);
      var catalgoueArray = UIMap.getDropdownOptions(
        catalogueResponse.catalogueList
      );
      this.updateState("catalgoueOptions", catalgoueArray);
      this.logger.info(catalogueResponse.catalogueList);
    } else {
      // this.showError("Catalogue", CrudlStatus.LIST);
    }
  };

  getCategorys = async id => {
    var categoryResponse = await this.getCategoryListByCatalogueId(id);
    if (Format.isNotNull(categoryResponse.categoryList)) {
      this.updateState("categoryList", categoryResponse.categoryList);
      this.logger.info(categoryResponse.categoryList);
      var categoryArray = UIMap.getDropdownOptions(
        categoryResponse.categoryList
      );
      this.updateState("categoryOptions", categoryArray);
    } else {
      // this.showError("Category", CrudlStatus.LIST);
    }
  };

  getOrders = async () => {
    let orderResponse = await this.getOrderListByCodeTag();
    if (
      Format.isNotNull(orderResponse.errorCode) &&
      orderResponse.errorCode === 0
    ) {
      if (Format.isNotNull(orderResponse.orderResponseList)) {
        this.updateState("orderList", orderResponse.orderResponseList);
        this.logger.info(orderResponse.orderResponseList);
      } else {
        this.showEmpty("Order");
      }
    } else {
      this.showError("Order", CrudlStatus.LIST);
    }
  };

  getOrdersReturned = async () => {
    let orderResponse = await this.getOrderListByCodeTag();
    if (
      Format.isNotNull(orderResponse.errorCode) &&
      orderResponse.errorCode === 0
    ) {
      if (Format.isNotNull(orderResponse.orderResponseList)) {
        return orderResponse.orderResponseList;
      } else {
        this.showEmpty("Order");
      }
    } else {
      this.showError("Order", CrudlStatus.LIST);
    }
  };

  reloadDataAfterExecute = (orders, apiResponse, type, externalStateValues) => {
    var updatedOrderList = [];
    if (type === CrudlStatus.CREATE) {
      updatedOrderList = this.reloadAfterCreate(
        orders,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.UPDATE) {
      updatedOrderList = this.reloadAfterUpdate(
        orders,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.DELETE) {
      updatedOrderList = this.reloadAfterDelete(
        orders,
        apiResponse,
        externalStateValues
      );
    }

    this.updateState("orderList", updatedOrderList);
  };

  reloadAfterCreate = (orderList, apiResponse, externalStateValues) => {
    if (orderList === undefined || orderList === null) {
      orderList = [];
    }
    var orderBean = externalStateValues.orderBean;
    orderBean.id = apiResponse.id;
    orderBean.lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;

    orderList.push(orderBean);

    return orderList;
  };

  reloadAfterUpdate = (orderList, apiResponse, externalStateValues) => {
    var i = 0;
    orderList.forEach(e => {
      if (apiResponse.id === e.id) {
        orderList[i] = externalStateValues.orderBean;
        orderList[i].lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;
      }
      i++;
    });

    return orderList;
  };

  reloadAfterDelete = (orderList, apiResponse, externalStateValues) => {
    var i = 0;
    orderList.forEach(e => {
      //DELETE
      if (apiResponse.id === e.id) {
        orderList.splice(i, 1);
      }
      i++;
    });

    return orderList;
  };
  executeCRUDLAction = async (crudlStatus, stateVariables) => {
    let orderRequest = CloudService.OrderV2Request.constructFromObject(
      stateVariables.orderBean
    );
    if (crudlStatus === CrudlStatus.CREATE) {
      return await this.createOrder(orderRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.UPDATE) {
      return await this.updateOrder(orderRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.DELETE) {
      return await this.deleteOrder(orderRequest);
    }
  };

  createOrder = async (orderRequest, stateVariables) => {
    orderRequest.codeTag = this.codeTag;
    orderRequest.userId = this.userId;

    orderRequest.orderItemList = stateVariables.orderItemList;
    delete orderRequest.orderItemResponseList;
    let orderResponse = await ApiService.orderCreate(orderRequest);
    if (orderResponse.errorCode === 0) {
      this.showSuccess("Order", CrudlStatus.CREATE);
    } else {
      this.showError("Order", CrudlStatus.CREATE);
    }

    return orderResponse;
  };

  deleteOrder = async orderRequest => {
    //RESET PRODUCT REQUEST
    var request = {};
    request.codeTag = this.codeTag;
    request.userId = this.userId;
    request.id = orderRequest.id;
    request.lastUpdatedDateTime = orderRequest.lastUpdatedDateTime;
    request.clientId = orderRequest.clientId;

    let orderResponse = await ApiService.orderDelete(request);
    if (orderResponse.errorCode === 0) {
      this.showSuccess("Order", CrudlStatus.DELETE);
    } else {
      this.showError("Order", CrudlStatus.DELETE);
    }

    return orderResponse;
  };

  updateOrder = async (orderRequest, stateVariables) => {
    orderRequest.codeTag = this.codeTag;
    orderRequest.userId = this.userId;
    delete orderRequest.orderItemResponseList;
    if (Format.isNotNull(stateVariables.deletedOrderItemList)) {
      stateVariables.deletedOrderItemList.forEach(element => {
        if (Format.isNotNull(element.id)) {
          if (!Format.isNotNull(stateVariables.orderItemList)) {
            stateVariables.orderItemList = [];
          }
          stateVariables.orderItemList.push(element);
        }
      });
    }
    orderRequest.orderItemList = stateVariables.orderItemList;
    this.logger.info(orderRequest);
    let orderResponse = await ApiService.orderUpdate(orderRequest);
    if (orderResponse.errorCode === 0) {
      this.showSuccess("Order", CrudlStatus.UPDATE);
    } else {
      this.showError("Order", CrudlStatus.UPDATE);
    }

    return orderResponse;
  };

  convertProductsToOrderItemRequests = products => {
    var orderItemRequestList = [];
    if (Format.isNotNull(products)) {
      products.forEach(element => {
        var orderItemRequest = {};

        var partProduct = { parts: [], products: [] };
        var productList = [];
        productList.push({
          id: element.id,
          quantity: parseFloat(element.quantity)
        });
        partProduct.products = productList;
        orderItemRequest.partProductJson = JSON.stringify(partProduct);
        orderItemRequest.quantity = element.quantity;
        orderItemRequest.unitPrice = 1.0;
        orderItemRequest.amount = 1.0;
        orderItemRequest.shipTogether = element.shipTogether;
        orderItemRequest.manufactureTogether = element.manufactureTogether;

        orderItemRequestList.push(orderItemRequest);
      });
    }

    return orderItemRequestList;
  };

  convertOrderItemResponseToRequest = orderItemResponseList => {
    if (Format.isNotNull(orderItemResponseList)) {
      orderItemResponseList.forEach(orderItem => {
        var partProductJson = JSON.parse(orderItem.partProductJson);
        if (Format.isNotNull(partProductJson.products)) {
          if (Format.isNotNull(partProductJson.products[0])) {
            var element = partProductJson.products[0];
            orderItem.quantity = element.quantity;
            orderItem.productName = element.name;
            orderItem.productDescription = element.shortDescription;
            orderItem.productId = element.id;
            orderItem.crudlStatus = CrudlStatus.UPDATE.value;
          }
        }
        orderItem.partProductJson = JSON.stringify(partProductJson);
      });
    }

    return orderItemResponseList;
  };

  createNewOrderItem = bean => {
    var orderItemRequest = {};
    var partProduct = { parts: [], products: [] };
    var productList = [];
    productList.push({
      id: bean.id,
      quantity: parseFloat(bean.quantity),
      name: bean.name,
      shortDescription: bean.shortDescription
    });
    partProduct.products = productList;
    orderItemRequest.partProductJson = JSON.stringify(partProduct);
    orderItemRequest.productId = bean.id;
    orderItemRequest.productName = bean.name;
    orderItemRequest.productDescription = bean.shortDescription;
    orderItemRequest.quantity = bean.quantity;
    orderItemRequest.unitPrice = 1.0;
    orderItemRequest.amount = 1.0;
    orderItemRequest.shipTogether = bean.shipTogether;
    orderItemRequest.manufactureTogether = bean.manufactureTogether;
    orderItemRequest.crudlStatus = CrudlStatus.CREATE.value;

    return orderItemRequest;
  };
}



// WEBPACK FOOTER //
// ./src/components/Orders/OrderViewModel.js